module.exports = "<div id=\"parentPageContent\">\r\n  <app-registration-form ></app-registration-form>\r\n</div>\r\n"